{
  "title": "AirPlx",
  "message": "Nous effectuons actuellement une maintenance planifiée. AirPlx sera de nouveau en ligne à {{endTime}}."
}
